// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  background-color: #f4f8fc;
  height: auto;
  /* ✅ remove 90vh */
  overflow: visible;
  /* ✅ allow page scroll */
}


.dashboard-header {
  display: flex;
  justify-content: space-between;
  background: white;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0px 2px 5px #d5d5d5;
  margin-bottom: 20px;
}

.dashboard-content {
  padding-top: 12px;
  padding-left: 30px;
  padding-right: 30px;
  background: var(--bg-light);
  min-height: 100vh;
}


.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-title {
  font-size: 20px;
  color: #333;
  font-weight: 600;
}

.search-container {
  margin-top: 30px;
  position: relative;
  width: 200px;

}

.search-icon {
  position: absolute;
  left: 10px;
  top: 10px;
  width: 20px;
}

.search-input {

  width: 100%;
  padding: 8px 4px 8px 4px;
  border-radius: 6px;
  border: 1px solid #ccc;

}

.search-card input {
  width: 450px;
  height: 44px;
  border-radius: 30px;
  padding: 0 45px 0 20px;
}

.filter-row {
  background: #fff;
  padding: 18px;
  border-radius: 30px;
  display: flex;
  align-items: flex-end;
  gap: 15px;
  flex-wrap: wrap;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.06);
  margin-bottom: 25px;
}

.filter-group label {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #333;
}

.filter-input {
  padding: 10px 14px;
  border-radius: 20px;
  border: 1px solid #ddd;
  min-width: 150px;
}


.download-btn {
  background: #1e5ad7;
  color: #fff;
  border: none;
  padding: 12px 22px;
  border-radius: 25px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}

.corner-bg {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 280px;
  opacity: 0.15;
  z-index: 0;
}

.table-card {
  background: #fff;
  border-radius: 25px;
  padding: 25px;
  margin-top: 25px;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.06);

  overflow: visible;
  /* ✅ no vertical scroll */
}

.table-scroll-wrapper {
  width: 100%;
  overflow-x: auto;
  /* ✅ only horizontal */
  overflow-y: hidden;
}

/* 
.table-card {
  background: white;
  border-radius: 14px;
  padding: 15px;
} */
.project-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 10px;
}

.project-table thead th {
  background: #eef3fb;
  padding: 14px;
  font-size: 14px;
  border-radius: 12px;
}

.project-table tbody tr {
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

.project-table td {
  padding: 14px;
}

.even-row {
  background: #ffffff;
}

.odd-row {
  background: #f5f7fa;
}

.pagination-section {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: 20px;
}

.pagination-controls button {
  border-radius: 10px;
  padding: 6px 12px;
}


.pagination-controls button.active {
  background: #007bff;
  color: white;
}

.main-content {
  padding-top: 80px;
  padding-left: 30px;
  padding-right: 30px;
  min-height: auto;     /* ✅ allow natural height */

  background: linear-gradient(135deg,
      #f8eaea 0%,
      #f4f8fc 55%);
}


.content-wrapper {
  background-color: #f4f8fc;
  padding: 20px;
  min-height: calc(100vh - 60px);
}

.dashboard-wrapper {
  display: flex;
  width: 100%;
  min-height: 100vh;
  overflow: visible;   /* ✅ allow body scroll */
}

/* SIDEBAR */
.sidebar-container {
  width: 250px;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  transition: transform 0.3s ease;
  z-index: 1001;
}

.sidebar-container.closed {
  transform: translateX(-250px);
}

.page-area {
  margin-left: 250px;
  width: calc(100% - 250px);
  transition: all 0.3s ease;
}

.page-area.full {
  margin-left: 0;
  width: 100%;
}

/* MAIN AREA */
.main-area {
  margin-left: 250px;
  transition: margin-left 0.3s ease;
}

.main-area.full {
  margin-left: 0;
}

.main-content {
  padding-top: 80px;
  padding-left: 30px;
  padding-right: 30px;
  min-height: 100vh;

  /* 🔥 REDDISH BACKGROUND */
  background: linear-gradient(135deg,
      #f8eaea 0%,
      #f4f8fc 55%);
}




@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
  }
}

.filter-row {
  background: #fff;
  border-radius: 25px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 18px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
}


.filter-group {
  display: flex;
  flex-direction: column;
}
.filter-input:disabled {
  background-color: #e0e0e0;      /* 🔥 darker than default */
  color: #666;                    /* readable text */
  border-color: #c5c5c5;
  cursor: not-allowed;
  opacity: 1;                     /* 🔥 override browser fade */
}

.filter-label {
  font-size: 13px;
  color: #555;
  margin-bottom: 4px;
  font-weight: 600;
}

/* MODAL */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-box h5 {
  margin-bottom: 15px;
  color: #2c2f48;
}

.modal-box {
  max-height: 70vh;
  /* 🔥 overall modal height */
  display: flex;
  flex-direction: column;
}

/* SCROLL ONLY WORKSHEET CONTENT */
.worksheet-text {
  background: #f5f6fa;
  padding: 15px;
  border-radius: 6px;
  margin: 12px 0;

  max-height: 260px;
  /* 🔥 controls scroll area */
  overflow-y: auto;

  white-space: pre-wrap;
  line-height: 1.5;
}

/* Optional smooth scrollbar */
.worksheet-text::-webkit-scrollbar {
  width: 6px;
}

.worksheet-text::-webkit-scrollbar-thumb {
  background: #bbb;
  border-radius: 4px;
}

.view-btn {
  background: #4b52a1;
  color: white;
  padding: 8px 14px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 10px;
}

.close-btn {
  background: #e74c3c;
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 6px;
  cursor: pointer;
}

.dashboard-header-card {
  background: #fff;
  padding: 18px 22px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 25px;
}

.dashboard-header-card h4 {
  font-weight: 600;
  color: #222;
}

.search-box {
  position: relative;
  width: 320px;
}

.search-box input {
  width: 100%;
  padding: 12px 40px 12px 18px;
  border-radius: 25px;
  border: 1px solid #ddd;
  outline: none;
}

.search-box span {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
}

.status {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 16px;
  font-weight: 600;
}

.status.in {
  background: #e8f7ee;
  color: #28a745;
}

.status.out {
  background: #fff0e6;
  color: #ff7a00;
}

.status.leave {
  background: #fdeaea;
  color: #e74c3c;
}

.top-navbar {
  height: 60px;
  background: var(--primary-red);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 25px;
  color: #fff;
}

.nav-left {
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 600;
}

.dash-icon {
  width: 26px;
  height: 26px;
}

.search-card {
  background: #fff;
  border-radius: 45px;
  padding: 20px 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 28px;

  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.06);
}

.search-card input {
  width: 420px;
  /* 🔥 LONG SEARCH */
  height: 42px;
  border-radius: 30px;
  border: 1px solid #ddd;
  padding: 0 20px;
}

.dashboard-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 20px;
  font-weight: 700;
  color: #222;
  margin-bottom: 18px;
}

.dashboard-icon {
  width: 28px;
  height: 28px;
}

/* Table */
.attendance-table {
  width: 100%;
  min-width: 1200px;   /* ✅ forces horizontal scroll */
  border-collapse: collapse;
  table-layout: fixed;
}
/* S.NO */
.attendance-table th:nth-child(1),
.attendance-table td:nth-child(1) {
  width: 70px;
  text-align: center;
  white-space: nowrap;
}
/* USER NAME */
.attendance-table th:nth-child(2),
.attendance-table td:nth-child(2) {
  width: 180px;
  word-break: break-word;
}

/* IN TIME */
.attendance-table th:nth-child(3),
.attendance-table td:nth-child(3) {
  width: 90px;
  white-space: nowrap;
}

/* OUT TIME */
.attendance-table th:nth-child(4),
.attendance-table td:nth-child(4) {
  width: 90px;
  white-space: nowrap;
}

/* TOTAL HOURS */
.attendance-table th:nth-child(5),
.attendance-table td:nth-child(5) {
  width: 110px;
  white-space: nowrap;
}

/* STATUS COLUMNS */
.attendance-table th:nth-child(6),
.attendance-table td:nth-child(6),
.attendance-table th:nth-child(7),
.attendance-table td:nth-child(7),
.attendance-table th:nth-child(8),
.attendance-table td:nth-child(8) {
  width: 120px;
  text-align: center;
}

/* MAP COLUMNS */
.attendance-table th:nth-child(9),
.attendance-table td:nth-child(9),
.attendance-table th:nth-child(10),
.attendance-table td:nth-child(10) {
  width: 140px;
}

/* IMAGE COLUMNS */
.attendance-table th:nth-child(11),
.attendance-table td:nth-child(12),
.attendance-table th:nth-child(13),
.attendance-table td:nth-child(13) {
  width: 100px;
  text-align: center;
}

/* WORKSHEET BUTTON */
.attendance-table th:nth-child(14),
.attendance-table td:nth-child(14) {
  width: 130px;
  text-align: center;
}

/* DATE */
.attendance-table th:nth-child(15),
.attendance-table td:nth-child(15) {
  width: 110px;
  white-space: nowrap;
}

/* =========================================================
   MOBILE RESPONSIVE DASHBOARD
========================================================= */

@media (max-width: 768px) {

  /* -------------------------
     MAIN WRAPPER
  ------------------------- */

  .dashboard-wrapper {
    display: block;
    width: 100%;
    min-height: 100vh;
    overflow-x: hidden;
  }


  /* -------------------------
     SIDEBAR
  ------------------------- */

  .sidebar-container {
    position: fixed !important;
    top: 0;
    left: 0;

    width: 250px !important;
    height: 100vh;

    z-index: 2000;

    transition: transform 0.3s ease;
  }

  .sidebar-container.closed {
    transform: translateX(-250px);
  }


  /* -------------------------
     PAGE AREA
  ------------------------- */

  .page-area,
  .page-area.full {
    width: 100% !important;
    margin-left: 0 !important;

    min-height: 100vh;
  }


  /* -------------------------
     MAIN CONTENT
  ------------------------- */

  .main-content {
    width: 100%;
    box-sizing: border-box;

    padding-top: 75px !important;
    padding-left: 12px !important;
    padding-right: 12px !important;
    padding-bottom: 30px !important;

    min-height: 100vh;
  }


  /* -------------------------
     CONTAINER
  ------------------------- */

  .main-content .container-fluid {
    width: 100%;
    max-width: 100%;

    padding-left: 0 !important;
    padding-right: 0 !important;
  }


  /* -------------------------
     DASHBOARD TITLE
  ------------------------- */

  .dashboard-title {
    font-size: 18px;
    gap: 8px;

    margin-bottom: 15px;
  }

  .dashboard-icon {
    width: 24px;
    height: 24px;
  }


  /* -------------------------
     SEARCH CARD
  ------------------------- */

  .search-card {
    width: 100%;
    box-sizing: border-box;

    display: flex;
    flex-direction: column;

    align-items: stretch;
    justify-content: center;

    gap: 15px;

    padding: 18px;

    border-radius: 22px;

    margin-bottom: 18px;
  }

  .search-card h2 {
    margin: 0;

    font-size: 20px;
    text-align: center;
  }

  .search-card > div {
    width: 100%;
  }

  .search-card input {
    width: 100% !important;
    max-width: 100%;

    height: 44px;

    box-sizing: border-box;

    padding: 0 45px 0 18px;
  }


  /* -------------------------
     FILTER ROW
  ------------------------- */

  .filter-row {
    width: 100%;
    box-sizing: border-box;

    display: grid;

    grid-template-columns: 1fr 1fr;

    gap: 12px;

    padding: 15px;

    border-radius: 22px;

    margin-bottom: 18px;
  }


  /* -------------------------
     FILTER GROUP
  ------------------------- */

  .filter-group {
    width: 100%;
    min-width: 0;
  }

  .filter-label {
    font-size: 12px;

    margin-bottom: 5px;
  }

  .filter-input {
    width: 100%;

    min-width: 0 !important;
    max-width: 100%;

    box-sizing: border-box;

    padding: 9px 10px;

    border-radius: 18px;

    font-size: 13px;
  }


  /* -------------------------
     DOWNLOAD BUTTON
  ------------------------- */

  .download-btn {
    grid-column: 1 / -1;

    width: 100%;

    height: 45px;

    padding: 10px 15px;

    font-size: 14px;
  }


  /* -------------------------
     TABLE CARD
  ------------------------- */

  .table-card {
    width: 100%;

    box-sizing: border-box;

    padding: 10px;

    margin-top: 18px;

    border-radius: 18px;

    overflow: hidden;
  }


  /* -------------------------
     TABLE HORIZONTAL SCROLL
  ------------------------- */

  .table-scroll-wrapper {
    width: 100%;

    overflow-x: auto;
    overflow-y: hidden;

    -webkit-overflow-scrolling: touch;

    scrollbar-width: thin;
  }

  .table-scroll-wrapper::-webkit-scrollbar {
    height: 7px;
  }

  .table-scroll-wrapper::-webkit-scrollbar-thumb {
    background: #bbb;
    border-radius: 10px;
  }

  .table-scroll-wrapper::-webkit-scrollbar-track {
    background: #f1f1f1;
  }


  /*
     Keep the table wide because it has many columns.
     The wrapper above will scroll horizontally.
  */

  .attendance-table {
    min-width: 1200px;

    width: 1200px;

    table-layout: fixed;
  }


  /* -------------------------
     TABLE FONT / SPACING
  ------------------------- */

  .attendance-table th {
    font-size: 12px;

    padding: 10px 8px;

    white-space: nowrap;
  }

  .attendance-table td {
    font-size: 12px;

    padding: 10px 8px;
  }


  /* -------------------------
     IMAGE SIZE
  ------------------------- */

  .attendance-table td img {
    width: 45px !important;
    height: 45px !important;

    object-fit: cover;
  }


  /* -------------------------
     MAP BUTTON
  ------------------------- */

  .attendance-table td button {
    font-size: 12px;
    white-space: nowrap;
  }


  /* -------------------------
     PAGINATION
  ------------------------- */

  .pagination-section {
    width: 100%;

    box-sizing: border-box;

    display: flex;

    flex-direction: column;

    align-items: center;

    gap: 12px;

    margin-top: 18px;
    margin-bottom: 20px;
  }

  .pagination-section p {
    margin: 0;

    font-size: 13px;

    text-align: center;
  }

  .pagination-controls {
    display: flex;

    justify-content: center;
    align-items: center;

    gap: 5px;

    flex-wrap: wrap;
  }

  .pagination-controls button {
    min-width: 38px;
    height: 38px;

    padding: 5px 10px;

    border-radius: 8px;

    font-size: 14px;
  }


  /* -------------------------
     WORKSHEET MODAL
  ------------------------- */

  .modal-overlay {
    padding: 15px;

    box-sizing: border-box;
  }

  .modal-box {
    width: 100%;
    max-width: 95vw;

    max-height: 80vh;

    padding: 18px;

    box-sizing: border-box;

    overflow: hidden;
  }

  .worksheet-text {
    max-height: 250px;

    overflow-y: auto;

    word-break: break-word;
  }
}


/* =========================================================
   SMALL MOBILE
========================================================= */

@media (max-width: 480px) {

  .main-content {
    padding-top: 70px !important;
    padding-left: 8px !important;
    padding-right: 8px !important;
  }


  /* Dashboard title */

  .dashboard-title {
    font-size: 17px;
  }


  /* Search */

  .search-card {
    padding: 15px;

    border-radius: 18px;
  }

  .search-card h2 {
    font-size: 18px;
  }


  /* Filters become one column */

  .filter-row {
    grid-template-columns: 1fr;

    padding: 12px;

    gap: 10px;
  }

  .download-btn {
    grid-column: auto;
  }


  /* Table */

  .table-card {
    padding: 7px;

    border-radius: 15px;
  }

  .attendance-table {
    min-width: 1200px;
  }


  /* Pagination */

  .pagination-controls button {
    min-width: 35px;

    height: 35px;

    padding: 4px 8px;
  }

  .pagination-section p {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/AdminDashboard.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;AACnB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;;AAEd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;;AAExB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;;AAGA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,YAAY;EACZ,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,2CAA2C;;EAE3C,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;;;GAKG;AACH;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;;AAGA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB,MAAM,2BAA2B;;EAEjD;;kBAEgB;AAClB;;;AAGA;EACE,yBAAyB;EACzB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,iBAAiB,IAAI,wBAAwB;AAC/C;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,OAAO;EACP,MAAM;EACN,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;;EAEjB,0BAA0B;EAC1B;;kBAEgB;AAClB;;;;;AAKA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2CAA2C;AAC7C;;;AAGA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,yBAAyB,OAAO,2BAA2B;EAC3D,WAAW,qBAAqB,kBAAkB;EAClD,qBAAqB;EACrB,mBAAmB;EACnB,UAAU,sBAAsB,6BAA6B;AAC/D;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,cAAc;;EAEd,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;;EAEhB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;;EAEnB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,UAAU;AACV;EACE,WAAW;EACX,iBAAiB,IAAI,+BAA+B;EACpD,yBAAyB;EACzB,mBAAmB;AACrB;AACA,SAAS;AACT;;EAEE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA,cAAc;AACd;;EAEE,YAAY;EACZ,sBAAsB;AACxB;;AAEA,YAAY;AACZ;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA,aAAa;AACb;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;;;;;;EAME,YAAY;EACZ,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;;;;EAIE,YAAY;AACd;;AAEA,kBAAkB;AAClB;;;;EAIE,YAAY;EACZ,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;;EAEE,YAAY;EACZ,kBAAkB;AACpB;;AAEA,SAAS;AACT;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;2DAE2D;;AAE3D;;EAEE;;6BAE2B;;EAE3B;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,kBAAkB;EACpB;;;EAGA;;6BAE2B;;EAE3B;IACE,0BAA0B;IAC1B,MAAM;IACN,OAAO;;IAEP,uBAAuB;IACvB,aAAa;;IAEb,aAAa;;IAEb,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;;EAGA;;6BAE2B;;EAE3B;;IAEE,sBAAsB;IACtB,yBAAyB;;IAEzB,iBAAiB;EACnB;;;EAGA;;6BAE2B;;EAE3B;IACE,WAAW;IACX,sBAAsB;;IAEtB,4BAA4B;IAC5B,6BAA6B;IAC7B,8BAA8B;IAC9B,+BAA+B;;IAE/B,iBAAiB;EACnB;;;EAGA;;6BAE2B;;EAE3B;IACE,WAAW;IACX,eAAe;;IAEf,0BAA0B;IAC1B,2BAA2B;EAC7B;;;EAGA;;6BAE2B;;EAE3B;IACE,eAAe;IACf,QAAQ;;IAER,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;;EAGA;;6BAE2B;;EAE3B;IACE,WAAW;IACX,sBAAsB;;IAEtB,aAAa;IACb,sBAAsB;;IAEtB,oBAAoB;IACpB,uBAAuB;;IAEvB,SAAS;;IAET,aAAa;;IAEb,mBAAmB;;IAEnB,mBAAmB;EACrB;;EAEA;IACE,SAAS;;IAET,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,eAAe;;IAEf,YAAY;;IAEZ,sBAAsB;;IAEtB,sBAAsB;EACxB;;;EAGA;;6BAE2B;;EAE3B;IACE,WAAW;IACX,sBAAsB;;IAEtB,aAAa;;IAEb,8BAA8B;;IAE9B,SAAS;;IAET,aAAa;;IAEb,mBAAmB;;IAEnB,mBAAmB;EACrB;;;EAGA;;6BAE2B;;EAE3B;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;;IAEf,kBAAkB;EACpB;;EAEA;IACE,WAAW;;IAEX,uBAAuB;IACvB,eAAe;;IAEf,sBAAsB;;IAEtB,iBAAiB;;IAEjB,mBAAmB;;IAEnB,eAAe;EACjB;;;EAGA;;6BAE2B;;EAE3B;IACE,mBAAmB;;IAEnB,WAAW;;IAEX,YAAY;;IAEZ,kBAAkB;;IAElB,eAAe;EACjB;;;EAGA;;6BAE2B;;EAE3B;IACE,WAAW;;IAEX,sBAAsB;;IAEtB,aAAa;;IAEb,gBAAgB;;IAEhB,mBAAmB;;IAEnB,gBAAgB;EAClB;;;EAGA;;6BAE2B;;EAE3B;IACE,WAAW;;IAEX,gBAAgB;IAChB,kBAAkB;;IAElB,iCAAiC;;IAEjC,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;;EAGA;;;GAGC;;EAED;IACE,iBAAiB;;IAEjB,aAAa;;IAEb,mBAAmB;EACrB;;;EAGA;;6BAE2B;;EAE3B;IACE,eAAe;;IAEf,iBAAiB;;IAEjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;;IAEf,iBAAiB;EACnB;;;EAGA;;6BAE2B;;EAE3B;IACE,sBAAsB;IACtB,uBAAuB;;IAEvB,iBAAiB;EACnB;;;EAGA;;6BAE2B;;EAE3B;IACE,eAAe;IACf,mBAAmB;EACrB;;;EAGA;;6BAE2B;;EAE3B;IACE,WAAW;;IAEX,sBAAsB;;IAEtB,aAAa;;IAEb,sBAAsB;;IAEtB,mBAAmB;;IAEnB,SAAS;;IAET,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,SAAS;;IAET,eAAe;;IAEf,kBAAkB;EACpB;;EAEA;IACE,aAAa;;IAEb,uBAAuB;IACvB,mBAAmB;;IAEnB,QAAQ;;IAER,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;;IAEZ,iBAAiB;;IAEjB,kBAAkB;;IAElB,eAAe;EACjB;;;EAGA;;6BAE2B;;EAE3B;IACE,aAAa;;IAEb,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;;IAEf,gBAAgB;;IAEhB,aAAa;;IAEb,sBAAsB;;IAEtB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;;IAEjB,gBAAgB;;IAEhB,sBAAsB;EACxB;AACF;;;AAGA;;2DAE2D;;AAE3D;;EAEE;IACE,4BAA4B;IAC5B,4BAA4B;IAC5B,6BAA6B;EAC/B;;;EAGA,oBAAoB;;EAEpB;IACE,eAAe;EACjB;;;EAGA,WAAW;;EAEX;IACE,aAAa;;IAEb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;;EAGA,8BAA8B;;EAE9B;IACE,0BAA0B;;IAE1B,aAAa;;IAEb,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;;EAGA,UAAU;;EAEV;IACE,YAAY;;IAEZ,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;;EAGA,eAAe;;EAEf;IACE,eAAe;;IAEf,YAAY;;IAEZ,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".dashboard-container {\r\n  background-color: #f4f8fc;\r\n  height: auto;\r\n  /* ✅ remove 90vh */\r\n  overflow: visible;\r\n  /* ✅ allow page scroll */\r\n}\r\n\r\n\r\n.dashboard-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  background: white;\r\n  padding: 15px;\r\n  border-radius: 8px;\r\n  box-shadow: 0px 2px 5px #d5d5d5;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.dashboard-content {\r\n  padding-top: 12px;\r\n  padding-left: 30px;\r\n  padding-right: 30px;\r\n  background: var(--bg-light);\r\n  min-height: 100vh;\r\n}\r\n\r\n\r\n.header-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.header-title {\r\n  font-size: 20px;\r\n  color: #333;\r\n  font-weight: 600;\r\n}\r\n\r\n.search-container {\r\n  margin-top: 30px;\r\n  position: relative;\r\n  width: 200px;\r\n\r\n}\r\n\r\n.search-icon {\r\n  position: absolute;\r\n  left: 10px;\r\n  top: 10px;\r\n  width: 20px;\r\n}\r\n\r\n.search-input {\r\n\r\n  width: 100%;\r\n  padding: 8px 4px 8px 4px;\r\n  border-radius: 6px;\r\n  border: 1px solid #ccc;\r\n\r\n}\r\n\r\n.search-card input {\r\n  width: 450px;\r\n  height: 44px;\r\n  border-radius: 30px;\r\n  padding: 0 45px 0 20px;\r\n}\r\n\r\n.filter-row {\r\n  background: #fff;\r\n  padding: 18px;\r\n  border-radius: 30px;\r\n  display: flex;\r\n  align-items: flex-end;\r\n  gap: 15px;\r\n  flex-wrap: wrap;\r\n  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.06);\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.filter-group label {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  margin-bottom: 6px;\r\n  color: #333;\r\n}\r\n\r\n.filter-input {\r\n  padding: 10px 14px;\r\n  border-radius: 20px;\r\n  border: 1px solid #ddd;\r\n  min-width: 150px;\r\n}\r\n\r\n\r\n.download-btn {\r\n  background: #1e5ad7;\r\n  color: #fff;\r\n  border: none;\r\n  padding: 12px 22px;\r\n  border-radius: 25px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n}\r\n\r\n.corner-bg {\r\n  position: fixed;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 280px;\r\n  opacity: 0.15;\r\n  z-index: 0;\r\n}\r\n\r\n.table-card {\r\n  background: #fff;\r\n  border-radius: 25px;\r\n  padding: 25px;\r\n  margin-top: 25px;\r\n  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.06);\r\n\r\n  overflow: visible;\r\n  /* ✅ no vertical scroll */\r\n}\r\n\r\n.table-scroll-wrapper {\r\n  width: 100%;\r\n  overflow-x: auto;\r\n  /* ✅ only horizontal */\r\n  overflow-y: hidden;\r\n}\r\n\r\n/* \r\n.table-card {\r\n  background: white;\r\n  border-radius: 14px;\r\n  padding: 15px;\r\n} */\r\n.project-table {\r\n  width: 100%;\r\n  border-collapse: separate;\r\n  border-spacing: 0 10px;\r\n}\r\n\r\n.project-table thead th {\r\n  background: #eef3fb;\r\n  padding: 14px;\r\n  font-size: 14px;\r\n  border-radius: 12px;\r\n}\r\n\r\n.project-table tbody tr {\r\n  background: #fff;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.project-table td {\r\n  padding: 14px;\r\n}\r\n\r\n.even-row {\r\n  background: #ffffff;\r\n}\r\n\r\n.odd-row {\r\n  background: #f5f7fa;\r\n}\r\n\r\n.pagination-section {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-top: 20px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.pagination-controls button {\r\n  border-radius: 10px;\r\n  padding: 6px 12px;\r\n}\r\n\r\n\r\n.pagination-controls button.active {\r\n  background: #007bff;\r\n  color: white;\r\n}\r\n\r\n.main-content {\r\n  padding-top: 80px;\r\n  padding-left: 30px;\r\n  padding-right: 30px;\r\n  min-height: auto;     /* ✅ allow natural height */\r\n\r\n  background: linear-gradient(135deg,\r\n      #f8eaea 0%,\r\n      #f4f8fc 55%);\r\n}\r\n\r\n\r\n.content-wrapper {\r\n  background-color: #f4f8fc;\r\n  padding: 20px;\r\n  min-height: calc(100vh - 60px);\r\n}\r\n\r\n.dashboard-wrapper {\r\n  display: flex;\r\n  width: 100%;\r\n  min-height: 100vh;\r\n  overflow: visible;   /* ✅ allow body scroll */\r\n}\r\n\r\n/* SIDEBAR */\r\n.sidebar-container {\r\n  width: 250px;\r\n  height: 100vh;\r\n  position: fixed;\r\n  left: 0;\r\n  top: 0;\r\n  transition: transform 0.3s ease;\r\n  z-index: 1001;\r\n}\r\n\r\n.sidebar-container.closed {\r\n  transform: translateX(-250px);\r\n}\r\n\r\n.page-area {\r\n  margin-left: 250px;\r\n  width: calc(100% - 250px);\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.page-area.full {\r\n  margin-left: 0;\r\n  width: 100%;\r\n}\r\n\r\n/* MAIN AREA */\r\n.main-area {\r\n  margin-left: 250px;\r\n  transition: margin-left 0.3s ease;\r\n}\r\n\r\n.main-area.full {\r\n  margin-left: 0;\r\n}\r\n\r\n.main-content {\r\n  padding-top: 80px;\r\n  padding-left: 30px;\r\n  padding-right: 30px;\r\n  min-height: 100vh;\r\n\r\n  /* 🔥 REDDISH BACKGROUND */\r\n  background: linear-gradient(135deg,\r\n      #f8eaea 0%,\r\n      #f4f8fc 55%);\r\n}\r\n\r\n\r\n\r\n\r\n@media (max-width: 768px) {\r\n  .main-content {\r\n    margin-left: 0;\r\n  }\r\n}\r\n\r\n.filter-row {\r\n  background: #fff;\r\n  border-radius: 25px;\r\n  padding: 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 18px;\r\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n\r\n.filter-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n.filter-input:disabled {\r\n  background-color: #e0e0e0;      /* 🔥 darker than default */\r\n  color: #666;                    /* readable text */\r\n  border-color: #c5c5c5;\r\n  cursor: not-allowed;\r\n  opacity: 1;                     /* 🔥 override browser fade */\r\n}\r\n\r\n.filter-label {\r\n  font-size: 13px;\r\n  color: #555;\r\n  margin-bottom: 4px;\r\n  font-weight: 600;\r\n}\r\n\r\n/* MODAL */\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 999;\r\n}\r\n\r\n.modal-box h5 {\r\n  margin-bottom: 15px;\r\n  color: #2c2f48;\r\n}\r\n\r\n.modal-box {\r\n  max-height: 70vh;\r\n  /* 🔥 overall modal height */\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n/* SCROLL ONLY WORKSHEET CONTENT */\r\n.worksheet-text {\r\n  background: #f5f6fa;\r\n  padding: 15px;\r\n  border-radius: 6px;\r\n  margin: 12px 0;\r\n\r\n  max-height: 260px;\r\n  /* 🔥 controls scroll area */\r\n  overflow-y: auto;\r\n\r\n  white-space: pre-wrap;\r\n  line-height: 1.5;\r\n}\r\n\r\n/* Optional smooth scrollbar */\r\n.worksheet-text::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.worksheet-text::-webkit-scrollbar-thumb {\r\n  background: #bbb;\r\n  border-radius: 4px;\r\n}\r\n\r\n.view-btn {\r\n  background: #4b52a1;\r\n  color: white;\r\n  padding: 8px 14px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  margin-top: 10px;\r\n}\r\n\r\n.close-btn {\r\n  background: #e74c3c;\r\n  color: white;\r\n  border: none;\r\n  padding: 8px 14px;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n}\r\n\r\n.dashboard-header-card {\r\n  background: #fff;\r\n  padding: 18px 22px;\r\n  border-radius: 30px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.dashboard-header-card h4 {\r\n  font-weight: 600;\r\n  color: #222;\r\n}\r\n\r\n.search-box {\r\n  position: relative;\r\n  width: 320px;\r\n}\r\n\r\n.search-box input {\r\n  width: 100%;\r\n  padding: 12px 40px 12px 18px;\r\n  border-radius: 25px;\r\n  border: 1px solid #ddd;\r\n  outline: none;\r\n}\r\n\r\n.search-box span {\r\n  position: absolute;\r\n  right: 15px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n}\r\n\r\n.status {\r\n  padding: 6px 12px;\r\n  border-radius: 20px;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n}\r\n\r\n.status.in {\r\n  background: #e8f7ee;\r\n  color: #28a745;\r\n}\r\n\r\n.status.out {\r\n  background: #fff0e6;\r\n  color: #ff7a00;\r\n}\r\n\r\n.status.leave {\r\n  background: #fdeaea;\r\n  color: #e74c3c;\r\n}\r\n\r\n.top-navbar {\r\n  height: 60px;\r\n  background: var(--primary-red);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 0 25px;\r\n  color: #fff;\r\n}\r\n\r\n.nav-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n.dash-icon {\r\n  width: 26px;\r\n  height: 26px;\r\n}\r\n\r\n.search-card {\r\n  background: #fff;\r\n  border-radius: 45px;\r\n  padding: 20px 32px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 28px;\r\n\r\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.search-card input {\r\n  width: 420px;\r\n  /* 🔥 LONG SEARCH */\r\n  height: 42px;\r\n  border-radius: 30px;\r\n  border: 1px solid #ddd;\r\n  padding: 0 20px;\r\n}\r\n\r\n.dashboard-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  color: #222;\r\n  margin-bottom: 18px;\r\n}\r\n\r\n.dashboard-icon {\r\n  width: 28px;\r\n  height: 28px;\r\n}\r\n\r\n/* Table */\r\n.attendance-table {\r\n  width: 100%;\r\n  min-width: 1200px;   /* ✅ forces horizontal scroll */\r\n  border-collapse: collapse;\r\n  table-layout: fixed;\r\n}\r\n/* S.NO */\r\n.attendance-table th:nth-child(1),\r\n.attendance-table td:nth-child(1) {\r\n  width: 70px;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n}\r\n/* USER NAME */\r\n.attendance-table th:nth-child(2),\r\n.attendance-table td:nth-child(2) {\r\n  width: 180px;\r\n  word-break: break-word;\r\n}\r\n\r\n/* IN TIME */\r\n.attendance-table th:nth-child(3),\r\n.attendance-table td:nth-child(3) {\r\n  width: 90px;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* OUT TIME */\r\n.attendance-table th:nth-child(4),\r\n.attendance-table td:nth-child(4) {\r\n  width: 90px;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* TOTAL HOURS */\r\n.attendance-table th:nth-child(5),\r\n.attendance-table td:nth-child(5) {\r\n  width: 110px;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* STATUS COLUMNS */\r\n.attendance-table th:nth-child(6),\r\n.attendance-table td:nth-child(6),\r\n.attendance-table th:nth-child(7),\r\n.attendance-table td:nth-child(7),\r\n.attendance-table th:nth-child(8),\r\n.attendance-table td:nth-child(8) {\r\n  width: 120px;\r\n  text-align: center;\r\n}\r\n\r\n/* MAP COLUMNS */\r\n.attendance-table th:nth-child(9),\r\n.attendance-table td:nth-child(9),\r\n.attendance-table th:nth-child(10),\r\n.attendance-table td:nth-child(10) {\r\n  width: 140px;\r\n}\r\n\r\n/* IMAGE COLUMNS */\r\n.attendance-table th:nth-child(11),\r\n.attendance-table td:nth-child(12),\r\n.attendance-table th:nth-child(13),\r\n.attendance-table td:nth-child(13) {\r\n  width: 100px;\r\n  text-align: center;\r\n}\r\n\r\n/* WORKSHEET BUTTON */\r\n.attendance-table th:nth-child(14),\r\n.attendance-table td:nth-child(14) {\r\n  width: 130px;\r\n  text-align: center;\r\n}\r\n\r\n/* DATE */\r\n.attendance-table th:nth-child(15),\r\n.attendance-table td:nth-child(15) {\r\n  width: 110px;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* =========================================================\r\n   MOBILE RESPONSIVE DASHBOARD\r\n========================================================= */\r\n\r\n@media (max-width: 768px) {\r\n\r\n  /* -------------------------\r\n     MAIN WRAPPER\r\n  ------------------------- */\r\n\r\n  .dashboard-wrapper {\r\n    display: block;\r\n    width: 100%;\r\n    min-height: 100vh;\r\n    overflow-x: hidden;\r\n  }\r\n\r\n\r\n  /* -------------------------\r\n     SIDEBAR\r\n  ------------------------- */\r\n\r\n  .sidebar-container {\r\n    position: fixed !important;\r\n    top: 0;\r\n    left: 0;\r\n\r\n    width: 250px !important;\r\n    height: 100vh;\r\n\r\n    z-index: 2000;\r\n\r\n    transition: transform 0.3s ease;\r\n  }\r\n\r\n  .sidebar-container.closed {\r\n    transform: translateX(-250px);\r\n  }\r\n\r\n\r\n  /* -------------------------\r\n     PAGE AREA\r\n  ------------------------- */\r\n\r\n  .page-area,\r\n  .page-area.full {\r\n    width: 100% !important;\r\n    margin-left: 0 !important;\r\n\r\n    min-height: 100vh;\r\n  }\r\n\r\n\r\n  /* -------------------------\r\n     MAIN CONTENT\r\n  ------------------------- */\r\n\r\n  .main-content {\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n\r\n    padding-top: 75px !important;\r\n    padding-left: 12px !important;\r\n    padding-right: 12px !important;\r\n    padding-bottom: 30px !important;\r\n\r\n    min-height: 100vh;\r\n  }\r\n\r\n\r\n  /* -------------------------\r\n     CONTAINER\r\n  ------------------------- */\r\n\r\n  .main-content .container-fluid {\r\n    width: 100%;\r\n    max-width: 100%;\r\n\r\n    padding-left: 0 !important;\r\n    padding-right: 0 !important;\r\n  }\r\n\r\n\r\n  /* -------------------------\r\n     DASHBOARD TITLE\r\n  ------------------------- */\r\n\r\n  .dashboard-title {\r\n    font-size: 18px;\r\n    gap: 8px;\r\n\r\n    margin-bottom: 15px;\r\n  }\r\n\r\n  .dashboard-icon {\r\n    width: 24px;\r\n    height: 24px;\r\n  }\r\n\r\n\r\n  /* -------------------------\r\n     SEARCH CARD\r\n  ------------------------- */\r\n\r\n  .search-card {\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    align-items: stretch;\r\n    justify-content: center;\r\n\r\n    gap: 15px;\r\n\r\n    padding: 18px;\r\n\r\n    border-radius: 22px;\r\n\r\n    margin-bottom: 18px;\r\n  }\r\n\r\n  .search-card h2 {\r\n    margin: 0;\r\n\r\n    font-size: 20px;\r\n    text-align: center;\r\n  }\r\n\r\n  .search-card > div {\r\n    width: 100%;\r\n  }\r\n\r\n  .search-card input {\r\n    width: 100% !important;\r\n    max-width: 100%;\r\n\r\n    height: 44px;\r\n\r\n    box-sizing: border-box;\r\n\r\n    padding: 0 45px 0 18px;\r\n  }\r\n\r\n\r\n  /* -------------------------\r\n     FILTER ROW\r\n  ------------------------- */\r\n\r\n  .filter-row {\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n\r\n    display: grid;\r\n\r\n    grid-template-columns: 1fr 1fr;\r\n\r\n    gap: 12px;\r\n\r\n    padding: 15px;\r\n\r\n    border-radius: 22px;\r\n\r\n    margin-bottom: 18px;\r\n  }\r\n\r\n\r\n  /* -------------------------\r\n     FILTER GROUP\r\n  ------------------------- */\r\n\r\n  .filter-group {\r\n    width: 100%;\r\n    min-width: 0;\r\n  }\r\n\r\n  .filter-label {\r\n    font-size: 12px;\r\n\r\n    margin-bottom: 5px;\r\n  }\r\n\r\n  .filter-input {\r\n    width: 100%;\r\n\r\n    min-width: 0 !important;\r\n    max-width: 100%;\r\n\r\n    box-sizing: border-box;\r\n\r\n    padding: 9px 10px;\r\n\r\n    border-radius: 18px;\r\n\r\n    font-size: 13px;\r\n  }\r\n\r\n\r\n  /* -------------------------\r\n     DOWNLOAD BUTTON\r\n  ------------------------- */\r\n\r\n  .download-btn {\r\n    grid-column: 1 / -1;\r\n\r\n    width: 100%;\r\n\r\n    height: 45px;\r\n\r\n    padding: 10px 15px;\r\n\r\n    font-size: 14px;\r\n  }\r\n\r\n\r\n  /* -------------------------\r\n     TABLE CARD\r\n  ------------------------- */\r\n\r\n  .table-card {\r\n    width: 100%;\r\n\r\n    box-sizing: border-box;\r\n\r\n    padding: 10px;\r\n\r\n    margin-top: 18px;\r\n\r\n    border-radius: 18px;\r\n\r\n    overflow: hidden;\r\n  }\r\n\r\n\r\n  /* -------------------------\r\n     TABLE HORIZONTAL SCROLL\r\n  ------------------------- */\r\n\r\n  .table-scroll-wrapper {\r\n    width: 100%;\r\n\r\n    overflow-x: auto;\r\n    overflow-y: hidden;\r\n\r\n    -webkit-overflow-scrolling: touch;\r\n\r\n    scrollbar-width: thin;\r\n  }\r\n\r\n  .table-scroll-wrapper::-webkit-scrollbar {\r\n    height: 7px;\r\n  }\r\n\r\n  .table-scroll-wrapper::-webkit-scrollbar-thumb {\r\n    background: #bbb;\r\n    border-radius: 10px;\r\n  }\r\n\r\n  .table-scroll-wrapper::-webkit-scrollbar-track {\r\n    background: #f1f1f1;\r\n  }\r\n\r\n\r\n  /*\r\n     Keep the table wide because it has many columns.\r\n     The wrapper above will scroll horizontally.\r\n  */\r\n\r\n  .attendance-table {\r\n    min-width: 1200px;\r\n\r\n    width: 1200px;\r\n\r\n    table-layout: fixed;\r\n  }\r\n\r\n\r\n  /* -------------------------\r\n     TABLE FONT / SPACING\r\n  ------------------------- */\r\n\r\n  .attendance-table th {\r\n    font-size: 12px;\r\n\r\n    padding: 10px 8px;\r\n\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .attendance-table td {\r\n    font-size: 12px;\r\n\r\n    padding: 10px 8px;\r\n  }\r\n\r\n\r\n  /* -------------------------\r\n     IMAGE SIZE\r\n  ------------------------- */\r\n\r\n  .attendance-table td img {\r\n    width: 45px !important;\r\n    height: 45px !important;\r\n\r\n    object-fit: cover;\r\n  }\r\n\r\n\r\n  /* -------------------------\r\n     MAP BUTTON\r\n  ------------------------- */\r\n\r\n  .attendance-table td button {\r\n    font-size: 12px;\r\n    white-space: nowrap;\r\n  }\r\n\r\n\r\n  /* -------------------------\r\n     PAGINATION\r\n  ------------------------- */\r\n\r\n  .pagination-section {\r\n    width: 100%;\r\n\r\n    box-sizing: border-box;\r\n\r\n    display: flex;\r\n\r\n    flex-direction: column;\r\n\r\n    align-items: center;\r\n\r\n    gap: 12px;\r\n\r\n    margin-top: 18px;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .pagination-section p {\r\n    margin: 0;\r\n\r\n    font-size: 13px;\r\n\r\n    text-align: center;\r\n  }\r\n\r\n  .pagination-controls {\r\n    display: flex;\r\n\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n    gap: 5px;\r\n\r\n    flex-wrap: wrap;\r\n  }\r\n\r\n  .pagination-controls button {\r\n    min-width: 38px;\r\n    height: 38px;\r\n\r\n    padding: 5px 10px;\r\n\r\n    border-radius: 8px;\r\n\r\n    font-size: 14px;\r\n  }\r\n\r\n\r\n  /* -------------------------\r\n     WORKSHEET MODAL\r\n  ------------------------- */\r\n\r\n  .modal-overlay {\r\n    padding: 15px;\r\n\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .modal-box {\r\n    width: 100%;\r\n    max-width: 95vw;\r\n\r\n    max-height: 80vh;\r\n\r\n    padding: 18px;\r\n\r\n    box-sizing: border-box;\r\n\r\n    overflow: hidden;\r\n  }\r\n\r\n  .worksheet-text {\r\n    max-height: 250px;\r\n\r\n    overflow-y: auto;\r\n\r\n    word-break: break-word;\r\n  }\r\n}\r\n\r\n\r\n/* =========================================================\r\n   SMALL MOBILE\r\n========================================================= */\r\n\r\n@media (max-width: 480px) {\r\n\r\n  .main-content {\r\n    padding-top: 70px !important;\r\n    padding-left: 8px !important;\r\n    padding-right: 8px !important;\r\n  }\r\n\r\n\r\n  /* Dashboard title */\r\n\r\n  .dashboard-title {\r\n    font-size: 17px;\r\n  }\r\n\r\n\r\n  /* Search */\r\n\r\n  .search-card {\r\n    padding: 15px;\r\n\r\n    border-radius: 18px;\r\n  }\r\n\r\n  .search-card h2 {\r\n    font-size: 18px;\r\n  }\r\n\r\n\r\n  /* Filters become one column */\r\n\r\n  .filter-row {\r\n    grid-template-columns: 1fr;\r\n\r\n    padding: 12px;\r\n\r\n    gap: 10px;\r\n  }\r\n\r\n  .download-btn {\r\n    grid-column: auto;\r\n  }\r\n\r\n\r\n  /* Table */\r\n\r\n  .table-card {\r\n    padding: 7px;\r\n\r\n    border-radius: 15px;\r\n  }\r\n\r\n  .attendance-table {\r\n    min-width: 1200px;\r\n  }\r\n\r\n\r\n  /* Pagination */\r\n\r\n  .pagination-controls button {\r\n    min-width: 35px;\r\n\r\n    height: 35px;\r\n\r\n    padding: 4px 8px;\r\n  }\r\n\r\n  .pagination-section p {\r\n    font-size: 12px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
